<template>
  <div class="background">
    <alerts-list fullVersion></alerts-list>
  </div>
</template>


<script>
import AlertsList from 'Common/alertsList';

export default {
  components: {
    AlertsList,
  },
};
</script>


<style lang="scss" scoped>
  .background {
    @include background(58px, 0px);
    $side-padding: 10px;
    padding-left: $side-padding;
    padding-right: $side-padding;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/AlertManagment.vue